import { render } from "./reclassify.html?vue&type=template&id=641ecb23&ts=true&external"
import script from "./reclassify.ts?vue&type=script&lang=ts&external"
export * from "./reclassify.ts?vue&type=script&lang=ts&external"

import "./reclassify.scss?vue&type=style&index=0&lang=scss&external"
import "@vueform/toggle/themes/default.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__